export const getTeamSpaceName = (teamId: string) => `team/${teamId}`
export const getRepoSpaceName = (teamId: string, repoId: string) =>
  `team/${teamId}/repo/${repoId}`

export const parseSpaceName = (
  spaceName: string
):
  | { spaceType: 'team'; teamId: string }
  | { spaceType: 'repo'; teamId: string; repoId: string } => {
  const splitted = spaceName.split('/')
  const spaceType = splitted.length === 2 ? 'team' : 'repo'
  if (spaceType === 'repo') {
    return {
      spaceType,
      teamId: splitted[1] as string,
      repoId: splitted[3] as string,
    }
  }
  return { spaceType, teamId: splitted[1] as string }
}
